<template>
    <article
        id="policy-details-insured-item"
        data-test-policy-insured-item
    >
        <h2>{{ value.LabelInsuredItemHeadline }}</h2>

        <field
            v-model="value.TypeOfVehicle"
            name="typeOfVehicle"
        />

        <field
            v-if="value.ShowTradeValue"
            v-model="value.TradeValue"
            name="tradeValue"
        />

        <field
            v-if="value.ShowUsage"
            v-model="value.Usage"
            name="usage"
        />

        <field
            v-if="value.ShowRegistrationNumber"
            v-model="value.RegistrationNumber"
            name="registrationNumber"
        />

        <field
            v-model="value.VinNumber"
            name="vinNumber"
        />

        <field
            v-model="value.Make"
            name="make"
        />

        <field
            v-model="value.Model"
            name="model"
        />

        <field
            v-model="value.Variant"
            name="variant"
        />

        <field
            v-model="value.Year"
            name="year"
        />

        <field
            v-if="value.ShowHorsePower"
            v-model="value.HorsePower"
            name="horsePower"
        />

        <field
            v-if="value.ShowEngineSize"
            v-model="value.EngineSize"
            name="engineSize"
        />
    </article>
</template>

<script>
import Field from '../Field.vue';

export default {
    name: 'OtherVehicle',
    components: {
        Field
    },
    props: {
        value: {
            type: Object,
            default() {
                return null;
            }
        }
    }
};
</script>
